import { NotAuthorizeError } from "../../ErrorType";
import { lang, useBfGlobals } from "../../Utils";

export const Error = ({error, title, message}) => {
  const globals = useBfGlobals();
  
  if (error instanceof NotAuthorizeError) {
    window.location = globals.get('links.logout');
    return;
  } 

  return (<div className="bf-error">
    <strong>{title || lang('We are Sorry.')}</strong>
    <p>{message || lang('Some error occured when retrieve data, please try again')}</p>
  </div>)
}